<template>
  <div>
    <v-aside />
    <v-main class="main">
      <v-container fluid>
        <template v-if="routeIsAllowed">
          <v-container fluid class="stat-page-top">
            <h1 class="mb-4">
              {{ pageTitle }}
            </h1>
            <breadcrumbs />
          </v-container>
          <router-view :key="$route.path" />
        </template>
        <access-denied v-else />
      </v-container>
      <update-app-massage />
    </v-main>
  </div>
</template>

<script>
  import vAside from '@/components/aside/Aside'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import _ from 'lodash'
  import AccessDenied from '@/components/app/AccessDenied.vue'
  import UpdateAppMassage from '@/components/UpdateAppMassage.vue'

  export default {
    name: 'StatisticDefaultLayout',
    components: {
      UpdateAppMassage,
      AccessDenied,
      vAside,
    },
    mixins: [mixinSnackbarMessage],
    computed: {
      pageTitle () {
        return this.$route.meta.pageTitle || 'Статистика'
      },
      routeIsAllowed () {
        if (_.isEmpty(this.$route?.meta?.permissions)) {
          return true
        }
        return this.userCan(this.$route.meta.permissions)
      },
    },
    created () {
      this.$store.commit('app/showFloatingButtons')
    },
  }
</script>

<style lang="less" scoped>
.stat-page-top {
  h1 {
    text-transform: uppercase;
    font-size: 24px;
    font-weight: 500;
  }
}
::v-deep {
  .v-main {
    transition: none !important;
    padding-top: 0 !important;
  }

  .media-lg({
    .v-main {
      padding-top: 20px !important;
      .container {
        padding: 0 5px;
      }
    }
  })
}
</style>
